import { fastlyOptionsType as fastlyOptionsTypeImport } from '../src/utils/imageHelpers';
export { getImageSrc } from '../src/utils/imageHelpers';
export type fastlyOptionsType = fastlyOptionsTypeImport;
